import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ExpandMore } from '@mui/icons-material';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Funciona si estamos bloqueadas?',
    a: 'Sí. El endulzamiento actúa sobre el campo energético, que no puede ser bloqueado por ninguna aplicación. Hay un ajuste específico para esta situación en el Tomo 2 y en el Bono 3.'
  }, {
    q: '¿Genera karma negativo?',
    a: 'No. Miel Roja es un sistema de "Frecuencia Limpia". No estamos dañando a nadie ni obligando. Estamos suavizando emociones para que el amor fluya. Si no hay amor de raíz, el ritual simplemente no actúa, pero nunca te hace daño.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Acceso inmediato a todos los PDFs en menos de 5 minutos desde tu pago. Podés abrirlos desde el celular, tablet o computadora.'
  }, {
    q: '¿Sirve para matrimonios o solo para noviazgos?',
    a: 'Sirve para cualquier vínculo amoroso: noviazgo, matrimonio, convivencia o relación no oficial. Los rituales se adaptan a cada situación.'
  }, {
    q: '¿Puedo hacerlo si no tengo privacidad?',
    a: 'Sí. El Bono 5 (Plantillas de Altar) tiene una versión "Modo Secreto" específica para cuando convivís con familia o pareja. Todo puede montarse en una caja o cajón en menos de 60 segundos.'
  }, {
    q: '¿Cómo pago?',
    a: 'Mercado Pago, tarjeta de crédito/débito y transferencia bancaria.'
  }];
  return <section className="py-16 px-4 bg-miel-dark relative" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="text-center mb-10" data-id="element-50">
            <h2 className="font-playfair text-3xl md:text-4xl text-miel-cream mb-4" data-id="element-51">
              Preguntas Frecuentes
            </h2>
            <div className="w-24 h-1 bg-miel-crimson mx-auto rounded-full" data-id="element-52" />
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-54">
              <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-miel-darker border-miel-crimson/50' : 'bg-miel-darker/50 border-miel-crimson/20 hover:border-miel-crimson/40'}`} data-id="element-55">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-56">
                  <span className="font-playfair text-lg text-miel-cream pr-8 flex gap-3" data-id="element-57">
                    <span className="text-miel-gold" data-id="element-58">❓</span> {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="text-miel-gold shrink-0" data-id="element-59">
                    <ExpandMore data-id="element-60" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-61">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-62">
                      <div className="px-6 pb-5 pt-0 text-miel-cream/80 text-sm md:text-base pl-14 border-t border-miel-crimson/10 mt-2 pt-4" data-id="element-63">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}